/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCurrentWorkingTeamMembersCountRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetCurrentWorkingTeamMembersCountResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getCurrentWorkingTeamMembersCount = (request: GetCurrentWorkingTeamMembersCountRequest, options?: CashRequestOptions) => post<GetCurrentWorkingTeamMembersCountRequest, GetCurrentWorkingTeamMembersCountResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/GetCurrentWorkingTeamMembersCount", request, {...options, rejectOnError: true })